import { get, patch, post, remove } from '@/api/base'

const emptyTemplatesApi = {
  get: async (containerUuid, emptyTemplateUuid) => {
    const response = await get({
      path: `containers/${containerUuid}/empty_templates/${emptyTemplateUuid}`,
    })
    return response.success ? response.data.empty_template : null
  },
  update: async (containerUuid, emptyTemplateUuid, params) => {
    const response = await patch({
      path: `containers/${containerUuid}/empty_templates/${emptyTemplateUuid}`,
      params: { ...params },
    })
    return response.success ? { ...response, emptyTemplate: response.data.empty_template } : response
  },
  create: async (containerUuid, params) => {
    return await post({
      path: `containers/${containerUuid}/empty_templates`,
      params: { ...params },
    })
  },
  delete: async (containerUuid, emptyTemplateUuid) => {
    return await remove({
      path: `containers/${containerUuid}/empty_templates/${emptyTemplateUuid}`,
    })
  },
  getFromGroup: async (containerGroupUuid, emptyTemplateUuid) => {
    const response = await get({
      path: `container_groups/${containerGroupUuid}/empty_templates/${emptyTemplateUuid}`,
    })
    return response.success ? response.data.empty_template : null
  },
  updateToGroup: async (containerGroupUuid, emptyTemplateUuid, params) => {
    return await patch({
      path: `container_groups/${containerGroupUuid}/empty_templates/${emptyTemplateUuid}`,
      params: { ...params },
    })
  },
  createToGroup: async (containerGroupUuid, params) => {
    return await post({
      path: `container_groups/${containerGroupUuid}/empty_templates`,
      params: { ...params },
    })
  },
  deleteFromGroup: async (containerGroupUuid, emptyTemplateUuid) => {
    return await remove({
      path: `container_groups/${containerGroupUuid}/empty_templates/${emptyTemplateUuid}`,
    })
  },
}

export default emptyTemplatesApi
